module.exports = __webpack_public_path__ + "static/media/haussmann_1.a2d49a5f.png";